import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
//import '@mattiasbuelens/web-streams-polyfill/dist/polyfill.min.js';
//import WebmWasmEngine from 'videojs-record/dist/plugins/videojs.record.webm-wasm.js';

const videoJsOptions = {
  controls: true,
  bigPlayButton: false,
  width: 1280,
  height: 720,
  fluid: true,
  videoMimeType: 'video/webm;codecs=vp9',
  controlBar: {
    deviceButton: false,
    recordToggle: false
  },
  plugins: {
    record: {
      audio: true,
      video: {
        width: 1280,
        height: 720
      },
      maxLength: 120,
      debug: true,
      frameWidth: 1280,
      frameHeight: 720
    }
  }
};

const root = ReactDOM.createRoot(document.getElementById('ugc-video-recorder'));
root.render(
  <App { ...videoJsOptions } />
);